import React from 'react'
import { Pressable, Text, TouchableOpacity, View } from 'react-native'
import { BOOT_TIMER_OPTIONS } from '@warcarp/api-types'
import { AppModal } from '../ui/AppModal'
import { useWebModalHistory } from '../../hooks/useWebModalHistory'

export function BootPlayerConfirmation({ name, botName, resignsInstead = false, turnHeld, bootAfterSeconds, pending, error, onCancel, onConfirm }: {
  name: string | null; botName?: string | null
  /**
   * Server rollback only (BOTS_IN_TEAM_GAMES_ENABLED=0, lib/aiTakeover.ts): the
   * preview says the seat resigns instead of going to a bot.
   */
  resignsInstead?: boolean
  turnHeld?: string | null; bootAfterSeconds: number
  pending: boolean; error?: string | null; onCancel: () => void; onConfirm: () => void
}) {
  const visible = !!name
  useWebModalHistory({ visible, canDismiss: !pending, onDismiss: onCancel })
  const timer = BOOT_TIMER_OPTIONS.find(option => option.seconds === bootAfterSeconds)?.label ?? '5 days'
  // The server previews who takes the seat (or, under its rollback flag, that the seat resigns).
  const ready = resignsInstead || !!botName
  return <AppModal visible={visible} transparent animationType="fade" onRequestClose={onCancel}>
    <View className="flex-1 items-center justify-center px-4" style={{ backgroundColor: 'rgba(0,0,0,0.65)' }}>
      <Pressable onPress={onCancel} style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0 }} />
      <View className="w-full rounded-2xl border-2 border-blood bg-paper p-5 gap-3" style={{ maxWidth: 430 }} testID="boot-confirm-modal">
        <Text className="font-stencil text-blood text-xs uppercase">⚠ Can&apos;t be undone</Text>
        <Text className="font-stencil text-ink text-lg">Boot {name}?</Text>
        <Text className="font-typed text-ink-soft text-xs">Turn held: {turnHeld ?? '—'} · Boot timer: {timer}</Text>
        <Text className="font-typed text-ink text-sm">Booting {name} means:</Text>
        {resignsInstead ? <>
          <Text className="font-typed text-ink text-sm">• {name} resigns: their territories turn neutral with their armies on them.</Text>
        </> : <>
          <Text className="font-typed text-ink text-sm">• {botName ? `A bot (${botName})` : 'A bot'} takes the seat for the rest of the game and plays this turn right away.</Text>
          <Text className="font-typed text-ink text-sm">• {name} can&apos;t come back to this game.</Text>
          <Text className="font-typed text-ink text-sm">• It counts as an abandoned game and a loss for {name}.</Text>
          <Text className="font-typed text-ink text-sm">• The game log will say you booted {name}.</Text>
        </>}
        {!!error && <Text className="font-typed text-blood text-sm" testID="boot-error">{error}</Text>}
        <View className="flex-row gap-2 mt-2">
          <TouchableOpacity onPress={onCancel} accessibilityRole="button" className="flex-1 border border-olive rounded-lg p-3 items-center"><Text className="font-stencil text-ink">Cancel</Text></TouchableOpacity>
          <TouchableOpacity onPress={onConfirm} disabled={pending || !ready} accessibilityRole="button" accessibilityLabel={`Confirm boot ${name}`} testID="confirm-boot-player" className="flex-1 bg-blood rounded-lg p-3 items-center justify-center" style={{ opacity: pending || !ready ? 0.5 : 1 }}><Text className="font-stencil text-white" numberOfLines={1}>⏏ Boot player</Text></TouchableOpacity>
        </View>
      </View>
    </View>
  </AppModal>
}
